export const pt = {
    title: `Esqueceu a senha`,
    description: `Digite seu e-mail e enviaremos instruções para redefinir`,
    success: `Verifique seu e-mail para as instruções de redefinição`,
    sendInstructions: `Enviar instruções de redefinição`,
    failure: `Falha ao enviar o e-mail de redefinição`,
};
//# sourceMappingURL=pt.js.map